import { right } from "@popperjs/core";
import React from "react";

interface DesktopModalProps {
  show: boolean;
  onClose: () => void;
}

const DesktopModal: React.FC<DesktopModalProps> = ({ show, onClose }) => {
  if (!show) return null;

  return (
    <div
      className="modal fade show custom-desktop-modal"
      style={{ display: "block" }}
      role="dialog"
      aria-modal="true"
      tabIndex={-1}
    >
      <div className="modal-dialog" style={{ maxWidth: 360, float: right }}>
        <div
          className="modal-content"
          style={{
            background: "linear-gradient(135deg, #001359 0%, #3C3163 50%, #453b93 80%, #928AD0 100%)",
            borderRadius: 20,
            border: "none",
            boxShadow: "0 8px 32px rgba(31, 38, 135, 0.37)",
            backdropFilter: "blur(8px)",
            position: "relative",
          }}
        >
          <div className="modal-header border-0">
            <div style={{ display: "flex", alignItems: "center" }}>
              <svg
                width="36"
                height="36"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ marginRight: 10 }}
              >
                <path
                  d="M12 3v12m0 0l-4-4m4 4l4-4"
                  stroke="#fff"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M20 17v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2"
                  stroke="#fff"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <h5
                className="modal-title mb-0"
                style={{
                  color: "#fff",
                  fontWeight: 700,
                  fontSize: 22,
                }}
              >
                Install Webs2PDF on Desktop
              </h5>
            </div>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={onClose}
              style={{ filter: "invert(1)", opacity: 0.7 }}
            ></button>
          </div>

          <div
            className="modal-body"
            style={{ color: "#fff", fontSize: 16, fontWeight: 400 }}
          >
            <ol style={{ paddingLeft: 20, marginBottom: 20 }}>
              <li style={{ marginBottom: 10 }}>
                Click the <b>Install</b>
                <span style={{ verticalAlign: "middle", margin: "0 4px" }}>
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M12 3v12m0 0l-4-4m4 4l4-4"
                      stroke="#fff"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                icon in the address bar.
                <div style={{ margin: "10px 0" }}>
                  <img
                    src="/dowload-icon .png"
                    alt="download icon"
                    style={{
                      width: "100px",
                      borderRadius: 10,
                      boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                    }}
                  />
                </div>
              </li>
              <li style={{ marginBottom: 10 }}>
                In the browser prompt, click <b>Install</b>.
                <div style={{ margin: "10px 0" }}>
                  <img
                    src="/install.png"
                    alt="PWA install prompt"
                    style={{
                      width: "100%",
                      borderRadius: 10,
                      boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                    }}
                  />
                </div>
              </li>
              <li>Enjoy Webs2PDF as a desktop app!</li>
            </ol>
            <div className="d-flex justify-content-end">
              <button
                className="btn btn-secondary"
                style={{ minWidth: 100, borderRadius: 10 }}
                onClick={onClose}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DesktopModal;
